export interface DefaultWithEntities<T> {
    entities: T;
}

export const Default = <T>(model: T) => model;

export const DefaultFor = <T>() => Default<T>;

export const DefaultEntities = <T>(model: DefaultWithEntities<T>) =>
    model.entities;
